import { Routes } from '@angular/router';
import { authGuard } from '@guards/auth.guard';
import { hasPermissionsGuard } from '@guards/has-permissions.guard';
import { MarcoFolioReversoPage } from './marco-folio-reverso/marco-folio-reverso.component';
import { ActosPage } from './actos/actos.component';
import { DigitalizacionPage } from './digitalizacion/digitalizacion.component';
import { CorreccionActaPage } from './correccion-acta/correccion-acta.component';

let moduleName = 'registro-civil';

export const registroCivil: Routes = [
  {
    path: `${moduleName}/buscar-acto`,
    component: ActosPage,
    title: 'Registro Civil - Buscar acto.',
    canActivate: [authGuard, hasPermissionsGuard(['registro_civil_buscar_acto_access'])],
  },
  {
    path: `${moduleName}/marco-folio-reverso`,
    component: MarcoFolioReversoPage,
    title: 'Registro Civil - Marcos, folios y reversos.',
    canActivate: [authGuard, hasPermissionsGuard(['registro_civil_marco_folio_reverso_access'])],
  },
  {
    path: `${moduleName}/digitalizacion`,
    component: DigitalizacionPage,
    title: 'Registro Civil - Digitalización.',
    canActivate: [authGuard, hasPermissionsGuard(['registro_civil_digitalizacion_access'])],
  },
  {
    path: `${moduleName}/correccion-acta`,
    component: CorreccionActaPage,
    title: 'Registro Civil - Corrección de acta.',
    canActivate: [authGuard, hasPermissionsGuard(['registro_civil_correccion_acta_access'])],
  },
];
